import React from "react";
import { DynamicField } from "./types";
import { parseMsDate, isDateType, FieldType } from "./dynamicFieldUtils";

interface LineItemsSectionProps {
    dynamicConfig: any;
    lineItems: any[];
    setLineItems: (items: any[]) => void;
    onAddNewLine: () => void;
    onEditLine: (item: any, index: number) => void;
    onDeleteLine?: (index: number) => void;
    readOnly?: boolean;
}

export const LineItemsSection: React.FC<LineItemsSectionProps> = ({
    dynamicConfig,
    lineItems,
    setLineItems,
    onAddNewLine,
    onEditLine,
    onDeleteLine,
    readOnly = false,
}) => {
    const tableHeaders = dynamicConfig?.configData?.parsedMultilineTableHeaders || dynamicConfig?.parsedMultilineTableHeaders || [];
    const visibleHeaders = tableHeaders.filter(
        (header: DynamicField) =>
            header.VisibleToEmployee === true || String(header.VisibleToEmployee) === "true"
    );
    const hasMultilineFields = visibleHeaders.length > 0;

    if (!hasMultilineFields) return null;

    return (
        <div className="row mt-4">
            <div className="col-12">
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                    <div className="card-header bg-white border-0 py-3 d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 text-dark fw-bold" style={{ color: "#A93226" }}>
                            <i className="ti ti-list-details me-2"></i>
                            Line Items
                        </h5>
                        {!readOnly && (
                            <button
                                type="button"
                                className="btn text-white px-4 py-2 rounded-pill shadow-sm"
                                style={{
                                    backgroundColor: "#A93226",
                                    fontSize: "14px",
                                }}
                                onClick={onAddNewLine}
                            >
                                <i className="ti ti-plus me-1"></i>
                                Add New Line
                            </button>
                        )}
                    </div>
                    <div className="card-body pt-0">
                        {lineItems.length > 0 ? (
                            <div className="table-responsive rounded-3 border">
                                <table className="table table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="ps-3">#</th>
                                            {visibleHeaders.map((header: DynamicField, idx: number) => (
                                                <th key={idx}>{header.Label}</th>
                                            ))}
                                            {!readOnly && <th className="text-end pe-3">Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lineItems.map((item, index) => (
                                             <tr key={index}>
                                                <td className="ps-3 fw-medium">{index + 1}</td>
                                                {visibleHeaders.map((header: DynamicField, idx: number) => {
                                                    const fieldName = (header.LineCustomerField || header.HeaderCustomerField || "") as string;
                                                    const fieldValue = item[fieldName];
                                                    let displayValue = "-";

                                                    if (fieldValue !== undefined && fieldValue !== null && fieldValue !== "") {
                                                        if (header.ViewOfFieldType === "C") {
                                                            displayValue = fieldValue === true || fieldValue === "true" || fieldValue === "YES" ? "Yes" : "No";
                                                        } else if (isDateType((header.ViewOfFieldType || "") as FieldType, fieldName, header.Label) || String(fieldValue).startsWith("/Date(")) {
                                                            displayValue = parseMsDate(fieldValue) || String(fieldValue);
                                                        } else {
                                                            displayValue = String(fieldValue);
                                                        }
                                                    }
                                                    return <td key={idx}>{displayValue}</td>;
                                                })}
                                                {!readOnly && (
                                                    <td className="text-end pe-3">
                                                        <div className="d-flex gap-2 justify-content-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-primary rounded-circle"
                                                                style={{ width: "32px", height: "32px", padding: 0 }}
                                                                onClick={() => onEditLine(item, index)}
                                                            >
                                                                <i className="ti ti-edit"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-danger rounded-circle"
                                                                style={{ width: "32px", height: "32px", padding: 0 }}
                                                                onClick={() => {
                                                                    if (onDeleteLine) {
                                                                        onDeleteLine(index);
                                                                    } else {
                                                                        setLineItems(lineItems.filter((_, i) => i !== index));
                                                                    }
                                                                }}
                                                            >
                                                                <i className="ti ti-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted bg-light rounded-3">
                                <i className="ti ti-receipt-off fs-32 d-block mb-2"></i>
                                {readOnly ? "No line items added." : 'No line items added yet. Click "Add New Line" to add entries.'}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
